import { type FC, type ReactNode, use, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import { InternalPageHeaderContext } from './InternalPageHeaderContext'

export const PageHeaderContext: FC<{ children: ReactNode }> = ({ children }) => {
  const [baseRoot, setBaseRoot] = useState<HTMLDivElement | null>(null)
  const [homeRoot, setHomeRoot] = useState<HTMLDivElement | null>(null)
  const [tabsRoot, setTabsRoot] = useState<HTMLDivElement | null>(null)
  const [toolsRoot, setToolsRoot] = useState<HTMLDivElement | null>(null)

  const memo = useMemo(
    () => ({
      baseRoot,
      setBaseRoot,
      homeRoot,
      setHomeRoot,
      tabsRoot,
      setTabsRoot,
      toolsRoot,
      setToolsRoot,
    }),
    [baseRoot, homeRoot, tabsRoot, toolsRoot],
  )

  return <InternalPageHeaderContext.Provider value={memo}>{children}</InternalPageHeaderContext.Provider>
}

export const PageHeaderContent: FC<{ children: ReactNode }> = ({ children }) => {
  const { baseRoot } = use(InternalPageHeaderContext)
  return baseRoot ? createPortal(children, baseRoot) : null
}

export const HeaderHomeContainer: FC<{ children: ReactNode }> = ({ children }) => {
  const { homeRoot } = use(InternalPageHeaderContext)
  return homeRoot ? createPortal(children, homeRoot) : null
}

export const HeaderTabsContainer: FC<{ children: ReactNode }> = ({ children }) => {
  const { tabsRoot } = use(InternalPageHeaderContext)
  return tabsRoot ? createPortal(children, tabsRoot) : null
}

export const HeaderToolsContainer: FC<{ children: ReactNode }> = ({ children }) => {
  const { toolsRoot } = use(InternalPageHeaderContext)
  return toolsRoot ? createPortal(children, toolsRoot) : null
}
